var _style, _circle, _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWriteWhiteYellow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 295 317",
    style: {
      enableBackground: "new 0 0 295 317"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 112.5888,
    y1: 286.4242,
    x2: 181.4112,
    y2: 29.5758
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01370162,
    style: {
      stopColor: "#FBC800"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7A807"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 147,
    cy: 158,
    r: 132.9
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_2_",
    cx: 147,
    cy: 158,
    r: 132.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_3_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_2_",
    style: {
      overflow: "visible"
    }
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M153.5,89.7l3.6-7.9c4.2-9.2,15.2-13.3,24.4-9.1l16,7.3c9.2,4.2,13.3,15.2,9.1,24.4l-3.6,7.9L153.5,89.7z  M154,219.4L137.8,230l-4.2-1.9l-22.4-10.2l-4.2-1.9l0,0l0,0l-2.6-19.2l47.4-103.5l49.5,22.6l0,0l0,0L154,219.4z M168.6,105.1 l-43.9,96l12.9,5.9l43.9-96L168.6,105.1z M153.8,98.4l-43.9,96l11.3,5.2l43.9-96L153.8,98.4z M137.5,225.6l12.9-8.4l-41.8-19.1 l2.1,15.3L137.5,225.6z M196.3,117.8l-11.3-5.2l-43.9,96l11.3,5.2L196.3,117.8z M106.6,221.3l2.9,21.4c0.2,1.5,1.1,2.7,2.5,3.4 c1.4,0.6,2.9,0.5,4.2-0.3l18-11.8L106.6,221.3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWriteWhiteYellow);
export default __webpack_public_path__ + "static/media/write-white-yellow.603af560d68bff6e52c9ae7594701177.svg";
export { ForwardRef as ReactComponent };